export default {
  completeRequests: {},
  completeRequest: {}
}
